import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ContentListing from "@/pages/ContentListing";
const ContentListingRoute = () => <ContentListing contentType="podcasts" pageTitle="Podcasts" pageDescription="Listen to expert discussions on regulatory strategy, clinical trials, and quality management in the life sciences industry." />;

export const Route = createFileRoute("/en/podcasts/")({
  head: () => buildRouteHead("/en/podcasts"),
  component: ContentListingRoute,
});

